import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import CustomAlert from "../../common/custom-alert/custom-alert";
import SpeechToText from "./SpeechToText";
import StackedBarChart from "../../common/custom-stacked-bar-chart/custom-stacked-bar-chart";
import db from "../../../assets/images/db.svg";
import DisableDB from "../../../assets/images/disable-db.svg";

const SelectDatabase = () => {
  const [isshowAlert, setIsShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertType, setAlertType] = useState("");
  const navigate = useNavigate();
  const data = [
    { name: "Page A", pv: 2400, uv: 4000 },
    { name: "Page B", pv: 1398, uv: 3000 },
    { name: "Page C", pv: 9800, uv: 2000 },
    { name: "Page D", pv: 3908, uv: 2780 },
    { name: "Page E", pv: 4800, uv: 1890 },
    { name: "Page F", pv: 3800, uv: 2390 },
    { name: "Page G", pv: 4300, uv: 3490 },
  ];

  const series = [
    { dataKey: "pv", name: "PV" },
    { dataKey: "uv", name: "UV" },
  ];
  const dbList =
    localStorage.getItem("userType") === "Sales"
      ? [
          { name: "Sales DM", imgUrl: db, isActive: true },
          { name: "Vendor DM", imgUrl: db, isActive: true },
          { name: "Sale DM", imgUrl: DisableDB, isActive: false },
          { name: "Vendor DM", imgUrl: DisableDB, isActive: false },
        ]
      : [
          { name: "Suppy Chain", imgUrl: db, isActive: true },
          { name: "Distributor DM", imgUrl: db, isActive: true },
          { name: "Sale Chain", imgUrl: DisableDB, isActive: false },
          { name: "Vendor Chain", imgUrl: DisableDB, isActive: false },
        ];

  const handleOnClosePopup = () => {
    setAlertType("");
    setAlertText("");
    setIsShowAlert(false);
  };
  const handleOnDbSelection = (dbName) => {
    setIsShowAlert(true);
    // if (dbName === "DB1" || dbName === "DB2") {
    //   setAlertType("success");
    //   setAlertText("Loading real-time dashboard for selected MySQL database");
    //   navigate("/dashboard");
    // } else {
    //   setAlertType("warning");
    //   setAlertText(
    //     `${dbName} is not yet activated soon will be available try with DB1 or DB2`
    //   );
    // }
  };

  return (
    <div className="dashbord-container w-100">
      <div className="dashbord-page-content">
        {isshowAlert ? (
          <CustomAlert type={alertType} onClose={handleOnClosePopup}>
            <span>{alertText}</span>
          </CustomAlert>
        ) : null}

        <div className="select-db-container">
          <div className="db-tile">
            <div className="db-title fw-bold fs-5">DataMart</div>
            <div className="d-flex">
              {dbList.map((db, index) => (
                <div
                  className="db-card text-center mx-4"
                  key={index}
                  onClick={() => handleOnDbSelection(db.name)}
                >
                  <div
                    className={
                      "db-card-img-div" + (db.isActive ? " active-db" : "")
                    }
                  >
                    <img src={db.imgUrl}></img>
                  </div>
                  <div
                    className={
                      "db-label" + (db.isActive ? " active-db-label" : "")
                    }
                  >
                    {db.name}
                  </div>
                </div>
              ))}
            </div>
            <button
              type="btn"
              style={{ width: "120px", height: "34px" }}
              className="generate-btn mt-1"
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              Click to Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectDatabase;
